const restclient = require('nordic/restclient');
const logger = require('nordic/logger');

const log = logger('dx_devsite');

const request = restclient({
  baseURL: 'https://api.mercadopago.com',
  timeout: 5000,
});

class preferencesService {
  static postPreferences(accessToken, customPreferenceData) {
    return request.post('/checkout/preferences', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      data: customPreferenceData || {
        items: [{
          title: 'Dummy Title',
          description: 'Dummy description',
          picture_url: 'http://www.myapp.com/myimage.jpg',
          category_id: 'car_electronics',
          quantity: 1,
          currency_id: null,
          unit_price: 10,
        }],
        purpose: 'onboarding_credits',
        payer: {
          phone: {},
          identification: {},
          address: {},
        },
        payment_methods: {
          excluded_payment_methods: [
            {},
          ],
          excluded_payment_types: [
            {},
          ],
        },
        shipments: {
          free_methods: [{}],
          receiver_address: {},
        },
        back_urls: {},
        differential_pricing: {},
        metadata: {},
      },
    })
      .then(response => response.data)
      .catch((err) => {
        log.error(`${err}`);
        console.log(err);
        throw err;
      });
  }
}

module.exports = preferencesService;

